<template>
    <div>
        <div class="row" v-if="showSummary">
            <div class="col-12 col-md-6 col-lg-4">
                <div class="card">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="card-title text-uppercase text-muted mb-2">{{$t('Today')}}</h6>
                                <span class="h2 mb-0">
                                    <money :value="lastPayments.today"></money>
                                </span>
                                <span
                                    class="badge mt-n1 ml-2"
                                    :class=" lastPayments.todayDif > 0 ? 'badge-soft-success' : 'badge-soft-danger' "
                                >{{ lastPayments.todayDif.toFixed(1) }} %</span>
                            </div>
                            <div class="col-auto">
                                <span class="h2 fe fe-dollar-sign text-muted mb-0"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-6 col-lg-4">
                <div class="card">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="card-title text-uppercase text-muted mb-2">{{$t('This week')}}</h6>
                                <span class="h2 mb-0">
                                    <money :value="lastPayments.thisWeek"></money>
                                </span>
                                <span
                                    class="badge mt-n1 ml-2"
                                    :class=" lastPayments.weekDif > 0 ? 'badge-soft-success' : 'badge-soft-danger'"
                                >{{ lastPayments.weekDif.toFixed(1) }} %</span>
                            </div>
                            <div class="col-auto">
                                <span class="h2 fe fe-dollar-sign text-muted mb-0"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-6 col-lg-4">
                <div class="card">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="card-title text-uppercase text-muted mb-2">{{$t('This month')}}</h6>
                                <span class="h2 mb-0">
                                    <money :value="lastPayments.thisMonth"></money>
                                </span>
                                <span
                                    class="badge mt-n1 ml-2"
                                    :class=" lastPayments.monthDif > 0 ? 'badge-soft-success' : 'badge-soft-danger' "
                                >{{ lastPayments.monthDif.toFixed(1) }} %</span>
                            </div>
                            <div class="col-auto">
                                <span class="h2 fe fe-dollar-sign text-muted mb-0"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-if="customerId">
            <div class="col-12 col-md-6 col-lg-4">
                <div class="card">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="card-title text-uppercase text-muted mb-2">{{$t('payments.total-paid')}}</h6>
                                <span class="h2 mb-0">
                                    <money :value="totals.income"></money>
                                </span>
                            </div>
                            <div class="col-auto">
                                <span class="h2 fe fe-dollar-sign text-muted mb-0"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-6 col-lg-4">
                <div class="card">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="card-title text-uppercase text-muted mb-2">{{$t('payments.total-services')}}</h6>
                                <span class="h2 mb-0">
                                    <money :value="totals.services"></money>
                                </span>
                            </div>
                            <div class="col-auto">
                                <span class="h2 fe fe-dollar-sign text-muted mb-0"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-6 col-lg-4">
                <div class="card">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="card-title text-uppercase text-muted mb-2">{{$t('payments.total-discount')}}</h6>
                                <span class="h2 mb-0">
                                    <money :value="totals.discount"></money>
                                </span>
                            </div>
                            <div class="col-auto">
                                <span class="h2 fe fe-dollar-sign text-muted mb-0"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-12">
                <!-- Card -->
                <div class="card" data-toggle="lists">
                    <div class="card-header">
                        <div class="row align-items-center">
                            <div class="col">
                                <slot name="table-header-left"></slot>
                            </div>
                            <!-- team filter -->
                            <div class="d-none d-xl-block col-auto" v-if="!customerId">
                                <permission-check resource="invoices" see-all>
                                    <team-filter v-model="users"></team-filter>
                                </permission-check>
                            </div>

                            <!-- date filter -->
                            <div class="d-none d-xl-block col-auto">
                                <date-filter v-model="dates" :initial="customerId ? '' : 'today'"></date-filter>
                            </div>

                            <!--Per Page filter -->
                            <div class="d-none d-xl-block col-auto" v-if="!customerId">
                                <div class="dropdown">
                                    <b-button-group>
                                        <button
                                            class="btn btn-white"
                                            v-if="selectedPerPage > 0"
                                            @click="perPageGenerator(0)"
                                        >
                                            <span class="fe fe-x"></span>
                                        </button>
                                        <b-dropdown variant="white" right :text="$t('Per page')">
                                            <b-dropdown-item
                                                @click="perPageGenerator(page)"
                                                v-for="(page, index) in perPageLabel"
                                                :key="index"
                                            >{{ page }}</b-dropdown-item>
                                        </b-dropdown>
                                    </b-button-group>
                                </div>
                            </div>

                            <div class="col-auto" v-if="customerId">
                                <b-button
                                    variant="info"
                                    @click="openModal({ id: 'transactionsModal', modal: {}})"
                                >{{ $t('Add payment') }}
                                </b-button>
                            </div>

                            <!-- filter button -->
                            <div class="col-auto d-xl-none">
                                <b-button @click="openModal({id:'transactionsTableFilterModal'})" variant="white" size="md">
                                    <i class="fe fe-filter"></i>
                                </b-button>
                            </div>

                        </div>
                        <!-- / .row -->
                    </div>
                    <div v-if="transactions.length" class="card-body">
                        <slot name="table">
                            <simple-table
                                :actions="false"
                                :columns="showDetailed ? detailedViewColumns : columns"
                                :data="transactions"
                                :loading="isDataLoading"
                            ></simple-table>
                        </slot>
                    </div>
                </div>

                <div class="card card-inactive" v-if="!isDataLoading && transactions.length==0">
                    <div class="card-body text-center text-muted small">
                        <div class="row justify-content-center">
                            <div class="col-12 mt-5">
                                <div class="d-flex justify-content-center">
                                    <img
                                        src="@/assets/img/illustrations/32desk/payments.svg"
                                        class="img-fluid mt-n5 mb-3"
                                        style="max-height: 400px;"
                                    />
                                </div>
                                <p class="text-muted mb-4">{{ $t('Nothing yet') }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <transaction-details-modal id="transactionDetailsModal" :parent="parent"></transaction-details-modal>
            <transactions-cancel-modal id="transactionsCancelModal"></transactions-cancel-modal>
        </div>

        <mobile-filters-modal id="transactionsTableFilterModal">
            <!-- team filter -->
            <div class="col-12 mb-3" v-if="!customerId">
                <permission-check resource="invoices" see-all>
                    <team-filter v-model="users"></team-filter>
                </permission-check>
            </div>

            <!-- date filter -->
            <div class="col-12 mb-3">
                <date-filter v-model="dates" :initial="customerId ? '' : 'today'"></date-filter>
            </div>

            <!--Per Page filter -->
            <div class="col-12 mb-3" v-if="!customerId">
                <div class="dropdown">
                    <b-button-group>
                        <button
                            class="btn btn-white"
                            v-if="selectedPerPage > 0"
                            @click="perPageGenerator(0)"
                        >
                            <span class="fe fe-x"></span>
                        </button>
                        <b-dropdown variant="white" right :text="$t('Per page')">
                            <b-dropdown-item
                                @click="perPageGenerator(page)"
                                v-for="(page, index) in perPageLabel"
                                :key="index"
                            >{{ page }}</b-dropdown-item>
                        </b-dropdown>
                    </b-button-group>
                </div>
            </div>
        </mobile-filters-modal>

    </div>
</template>

<script>

import debounce from 'lodash/debounce';
import Money from '@/components/Money.vue';
import {modalMixins} from '@/mixins/modal.js'
import DateFilter from '@/components/DateFilter.vue';
import StatusBadge from '@/components/StatusBadge.vue';
import {mapActions, mapGetters, mapState} from 'vuex';
import TeamFilter from "@/components/TeamFilter";
import TransactionsModal from "./TransactionsModal";
import InvoiceModal from '@/Pages/Sales/InvoiceModal.vue';
import TransactionsCancelModal from "./TransactionsCancelModal";
import TransactionDetailsModal from "./TransactionDetailsModal";
import SimpleTable from "@/components/SimpleTable";
import CustomSwitch from "./CustomSwitch";
import mobileFiltersModal from "@/components/mobileFiltersModal";

export default {
    mixins: [modalMixins],
    props: { customerId: null, showSummary: Boolean },
    components: {
        CustomSwitch,
        SimpleTable,
        TransactionDetailsModal,
        Money,
        DateFilter,
        TeamFilter,
        StatusBadge,
        TransactionsModal,
        InvoiceModal,
        TransactionsCancelModal,
        mobileFiltersModal
    },
    data() {
        return {
            hideForm: false,
            columns: [
                {
                    label: 'Date',
                    name: 'createdAt',
                    date_format: 'DD MMMM',
                    click: (item) => {
                        this.openDetailsModal(item)
                    }
                },
                {
                    label: 'Status',
                    name: 'status',
                    field: (item) => {
                        if (item.cancelled)
                            return `<span class="badge badge-danger badge-pill">${this.$t('Cancelled')}</span>`;

                        if (item.paidTotal < Math.abs(item.amount))
                            return `<span class="badge badge-warning badge-pill">${this.$t('Paid partially')}</span>`;

                        if (
                                item.amount < 0 &&
                                item.status == 'topup'
                        )
                            return `<span class="badge badge-soft-danger badge-pill">${this.$t('payment.status.debiting-from-balance')}</span>`;

                        if (item.paymentMethod == 'userBalance')
                            return `<span class="badge badge-soft-danger badge-pill">${this.$t('payment.status.debiting-from-balance')}</span>`;

                        if (item.status === 'topup')
                            return `<span class="badge badge-success badge-pill">${this.$t('Paid')} (${this.$t('Balance top up')})</span>`;

                        return `<span class="badge badge-success badge-pill">${this.$t('Paid')}</span>`;
                    }
                },
                {
                    label: 'Customer',
                    name: 'customer',
                    field: (item) => {
                        if (!item.customer) return '';
                        return item.customer.first_name + ' ' + item.customer.last_name;
                    }
                },
                {
                    label: 'Paid amount',
                    name: 'paidTotal',
                    field: (item) => {
                        return Math.abs(item.paidTotal);
                    },
                    money: true
                },
                {
                    label: 'Amount',
                    name: 'paidAmount',
                    field: (item) => {
                        return Math.abs(item.amount);
                    },
                    money: true
                },
                // {
                //     label: 'Balance',
                //     name: 'balance',
                //     field: (item) => {
                //         return item.balance;
                //     },
                //     money: true
                // },
            ],
            detailedViewColumns: [
                {
                    label: 'Date',
                    name: 'date',
                    field: (item) => {
                        if (!item.date) return '';
                        return item.date
                    },
                    date_format: 'DD MMMM'
                },
                {
                    label: 'Customer',
                    name: 'customer',
                    field: (item) => {
                        if (!item.customer) return '';
                        return item.customer.first_name + ' ' + item.customer.last_name;
                    }
                },
                {
                    label: 'Cash',
                    name: 'cash',
                    field: (item) => {
                        return item.cash;
                    },
                    money: true
                },
                {
                    label: 'Card',
                    name: 'card',
                    field: (item) => {
                        return item.card;
                    },
                    money: true
                },
                {
                    label: 'Total',
                    name: 'total',
                    field: (item) => {
                        return item.total
                    },
                    money: true
                }
            ],
            perPageLabel: [10, 20, 50, 100, 200],
            dates: {},
            users: [],
            parent: {},
            showDetailed: false,
            params: {
                query: {
                    $limit: 1000,
                    customerId: this.$route.params.id,
                    $or: [{ parentId: null }, { status: 'topup' }, { paymentMethod: 'userBalance' }],
                    $sort: {
                        date: -1,
                    }
                }
            },
            lastPayments: {
                today: 0,
                thisWeek: 0,
                thisMonth: 0,
                todayDif: 0,
                weekDif: 0,
                monthDif: 0,
            },
            currentPage: 1,
            perPage: 50,
            selectedPerPage: null,
            modalName: 'customerFormModal',
            model: {},
            dateFilter: null,
            totals: {
                income: 0,
                services: 0,
                discount: 0
            }
        };
    },
    computed: {
        ...mapState('transactions', { isDataLoading: 'isFindPending' }),
        ...mapGetters('transactions', { findDataInStore: 'find' }),
        ...mapState('my-team', { isTeamLoading: 'isFindPending' }),
        ...mapGetters('my-team', { findTeamInStore: 'find' }),

        team() {
            return this.findTeamInStore({}).data;
        },

        byDateLabel() {
            if (this.date_range == 'custom')
                return this.date;
            else
                return this.labels[this.date_range];
        },

        transactions() {
            if (this.showDetailed) {
                return this.detailedTransactions
            }
            return this.findDataInStore(this.params).data;
        },

        detailedTransactions() {
            let transactions = this.findDataInStore(this.params).data;
            transactions = this.$groupBy(transactions, item => item.invoiceId);
            transactions = Object.values(transactions).map(items => {
                let empty = {
                    date: items[0].date,
                    customer: items[0].customer,
                    cash: 0,
                    card: 0,
                    total: 0
                };
                return items.reduce((total, transaction) => {
                    if (transaction.paymentMethod === 'cash') {
                        total.cash += transaction.paidTotal;
                        total.total += total.cash;
                    } else if (transaction.paymentMethod === 'card') {
                        total.card += transaction.paidTotal;
                        total.total += total.card;
                    }
                    return total
                }, empty)
            });
            let summary = transactions.reduce((summary, transaction) => {
                summary.cash += transaction.cash;
                summary.card += transaction.card;
                summary.total += transaction.total;
                return summary
            }, { cash: 0, card: 0, total: 0 });
            transactions.push(summary);
            return transactions;
        }
    },
    created() {
        this.fetchTransactions();
        this.fetchSummary();
    },

    watch: {
        showDetailed: debounce(function () {
            return this.fetchTransactions();
        }, 200),

        dateFilter: debounce(function (dates) {
            if (dates.start) {
                this.params.query.date = {
                    $gte: dates.start,
                    $lte: dates.end
                }
            } else {
                delete this.params.query.date;
            }
            this.fetchTransactions();
        }, 100),

        dates: debounce(function (dates) {
            this.fetchTransactions();
        }, 100),

        currentPage: debounce(function (newVal) {
            this.fetchTransactions();
        }, 100),

        users: debounce(function (users) {
            this.fetchTransactions();
            this.fetchSummary();
        }, 100),
    },

    methods: {
        ...mapActions('transactions', { findTransactions: 'find' }),
        ...mapActions('invoices-summary', { fetchSummary: 'find' }),
        ...mapActions('customers', { fetchCustomer: 'get' }),
        ...mapActions('invoices-summary', ['find']),

        fetchSummary() {
            let params = {
                query: {
                    $limit: this.perPage,
                    $skip: (this.currentPage - 1) * this.perPage,
                    $sort: {
                        date: -1
                    },
                    $or: [{ parentId: null }, { status: 'topup' }],
                }
            };

            if (this.users.length)
                params.query.user = { $in: this.users };
            else
                delete params.query.user;

            this.find(this.params).then(data => {
                let p = data[0];
                this.lastPayments = Object.assign(this.lastPayments, p);
                if (p.today && p.yesterday)
                    if ((p.today - p.yesterday) > 0)
                        this.lastPayments.todayDif = 100 / ((p.today - p.yesterday) / p.yesterday);
                    else this.lastPayments.todayDif = 100 * ((p.today - p.yesterday) / p.yesterday);
                if (p.thisWeek && p.lastWeek)
                    if ((p.thisWeek - p.lastWeek) > 0)
                        this.lastPayments.weekDif = 100 / ((p.thisWeek - p.lastWeek) / p.lastWeek);
                    else this.lastPayments.weekDif = 100 * ((p.thisWeek - p.lastWeek) / p.lastWeek);
                if (p.thisMonth && p.lastMonth)
                    if ((p.thisMonth - p.lastMonth) > 0)
                        this.lastPayments.monthDif = 100 / ((p.thisMonth - p.lastMonth) / p.lastMonth);
                    else this.lastPayments.monthDif = 100 * ((p.thisMonth - p.lastMonth) / p.lastMonth);
            });
        },

        fetchTransactions() {
            let params = {
                query: {
                    $limit: this.perPage,
                    $skip: (this.currentPage - 1) * this.perPage,
                    $sort: {
                        date: -1
                    }
                }
            };

            if (this.showDetailed) {
                params.query.parentId = { $ne: null };
                params.query.paymentMethod = { $ne: null };
                params.query.cancelled = false;
            } else {
                params.query.$or = [{ parentId: null }, { status: 'topup' }, { paymentMethod: 'userBalance' }];
            }

            if (this.customerId)
                params.query.customerId = this.customerId;
            else
                delete params.query.customerId;

            if (this.users.length)
                params.query.userId = { $in: this.users };
            else
                delete params.query.userId;

            if (this.dates.start && this.dates.end) {
                params.query.date = {
                    $gte: this.dates.start,
                    $lte: this.dates.end
                }
            }
            this.params = params;
            this.findTransactions(this.params).then( transactions => {
                let totals = transactions.totals;
                if (!totals) return;
                this.totals = {
                    income: totals.income,
                    services: totals.services,
                    discount: totals.discount
                };
            });
        },

        perPageGenerator(perPage) {
            this.selectedPerPage = perPage;
            if (perPage > 0)
                this.perPage = perPage;
            else {
                this.perPage = 5;
                this.selectedPerPage = 0;
            }
            this.fetchTransactions();
        },

        openCancelModal(transaction) {
            let item = {
                model: transaction,
                _id: 'temp'
            };
            const { Transaction } = this.$FeathersVuex;
            new Transaction(item);
            this.openModal({ id: 'transactionsCancelModal' });
        },

        openDetailsModal(transaction) {
            this.parent = transaction;
            this.openModal({ id: 'transactionDetailsModal' })
        },




    }
}
</script>

<style lang="scss">
.income {
    color: #007000;
}

.outcome {
    color: #5f1109;
}
</style>
